import { sectionConfig } from './../app/features/home/views/home/data/section-container.57.data';

export const environment = {
  name: '(STAGING)',
  production: true,
  //baseUrl: "http://localhost:3000",
  baseUrl: 'https://apitest.tiendanegocio.com',
  baseIP: 'http://10.116.0.16:3003',
  galleryUrl: "https://cdn.v2.tiendanegocio.com/",
  assetsUrl: "https://cdn.v2.tiendanegocio.com/template_dev/",
  edgeUrl: "https://cdn.v2.tiendanegocio.com/template_dev/",
  template_id: 57,
  hostname: 'templatetest.tiendanegocio.com',
  options: {
    withPreferencesForm: false,
    countRecommendProduct: 5,
    countColumnProduct: 4,
    countColumnProductSearch: 4,
    sectionsInfo: sectionConfig,
    imageSizeDefault: 'sm',
    iconFontWeight: 300
  }
};
